import TradeInPage from "../../components/TradeIn/TradeInPage";

const TradeInContainer = () => {
  return <TradeInPage />;
};

export default TradeInContainer;
